import { AntTooltip } from '../../../../common/AntTooltip';

const CopyToAll: React.FC<{
    id: string;
    tableId: string;
    onClick: () => void;
    className?: string;
}> = ({ id, onClick, tableId, className }) => {
    const handleCopy = () => {
        onClick();

        const tableEl = document.getElementById(tableId);
        const copyEl = document.getElementById(id);

        if (!tableEl || !copyEl) {
            return;
        }

        tableEl.onanimationend = () => {
            tableEl?.classList.remove('flash-mx-duration');
            copyEl?.classList?.remove('copied');
        };

        tableEl?.classList.add('flash-mx-duration');
        copyEl?.classList.add('copied');
    };

    return (
        <AntTooltip placement="top" content={'Copy for all'}>
            <div className={`absolute bottom-2 right-2 ${className ? className : ''}`}>
                <div id={id} className="copy-duration-v2 absolute" onClick={handleCopy}>
                    <svg
                        className="copy"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path d="M502.6 70.63l-61.25-61.25C435.4 3.371 427.2 0 418.7 0H255.1c-35.35 0-64 28.66-64 64l.0195 256C192 355.4 220.7 384 256 384h192c35.2 0 64-28.8 64-64V93.25C512 84.77 508.6 76.63 502.6 70.63zM464 320c0 8.836-7.164 16-16 16H255.1c-8.838 0-16-7.164-16-16L239.1 64.13c0-8.836 7.164-16 16-16h128L384 96c0 17.67 14.33 32 32 32h47.1V320zM272 448c0 8.836-7.164 16-16 16H63.1c-8.838 0-16-7.164-16-16L47.98 192.1c0-8.836 7.164-16 16-16H160V128H63.99c-35.35 0-64 28.65-64 64l.0098 256C.002 483.3 28.66 512 64 512h192c35.2 0 64-28.8 64-64v-32h-47.1L272 448z"></path>
                    </svg>
                    <svg
                        className="copied"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                    >
                        <path d="M480.1 159c-9.375-9.375-24.56-9.375-33.94 0L192 414.1L64.97 287c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94l144 144C179.7 469.7 185.8 472 192 472s12.28-2.344 16.97-7.031l272-272C490.3 183.6 490.3 168.4 480.1 159zM175 240.1C179.7 245.7 185.8 248 192 248s12.28-2.344 16.97-7.031l176-176c9.375-9.375 9.375-24.56 0-33.94s-24.56-9.375-33.94 0L192 190.1L112.1 111c-9.375-9.375-24.56-9.375-33.94 0s-9.375 24.56 0 33.94L175 240.1z"></path>
                    </svg>
                </div>
            </div>
        </AntTooltip>
    );
};

export default CopyToAll;
